<mat-toolbar color="primary" class="app-header">
  <pp-navigate-back />
  @if (!layoutService.isSmallDevice()) {
    <button mat-icon-button (click)="sidenavToggle()" aria-label="Toggle the navigation sidebar">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <!--
    Renders on a handset only, where the sidenav renders nothing, from the APPLICATION_CONTEXT's
    routes. Not in design mode: the designer brings its own navigation.
  -->
  @if (!isDesignRoute()) {
    <pp-nav-menu />
  }
  <!-- The application's name from the APPLICATION_CONTEXT, unless design mode overrides it. Grows to fill the row. -->
  <pp-app-title [title]="titleOverride()" />
  <pp-language-selector />
  <!--
    The way into the designer, and — once inside — the way back out. Only rendered for a customer
    whose URL named an organization: without one there is no `/{orgKey}/design` to link to, and
    `DESIGN_ROUTE_PREFIX` is `''`, so the button would navigate to a root `/design` that this
    application does not mount.
  -->
  <!-- Only with more than one organization on the account; see OrganizationSwitcherComponent. -->
  @if (hasOrganization) {
    <app-organization-switcher />
  }
  @if (hasOrganization) {
    <pp-design-button />
  }
  <pp-auth-button />
</mat-toolbar>
